const legalItems = [
  {
    label: "Country",
    value: "Registered in Tanzania",
  },
  {
    label: "BRELA Registration",
    value: "Certificate No. 135771",
  },
  {
    label: "Building Contractor",
    value: "CRB Registration No. B5/1967/07/2025",
  },
  {
    label: "Civil Contractor",
    value: "CRB Registration No. C/1888/07/2025",
  },
];

export default function HomeLegalStatus() {
  return (
    <section className="tgm-section tgm-legal-preview" data-aos="fade-up">
      <div className="container">
        <div className="tgm-legal-preview-shell">
          <div className="tgm-legal-preview-copy">
            <p className="tgm-section-kicker">Legal Status</p>
            <h2>Registered and positioned for civil and building works.</h2>
            <p>
              SMART TGM Limited operates with recognized company and contractor
              registrations, supporting confidence before project execution
              begins.
            </p>
          </div>

          <div className="tgm-legal-grid">
            {legalItems.map((item) => (
              <div className="tgm-legal-card" key={item.label}>
                <span>{item.label}</span>
                <strong>{item.value}</strong>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
